const DEFAULT_MAX_SINGLE_LINE_CHARS = 72;

export interface TextNeedsTableDescriptionExpandOptions {
  maxSingleLineChars?: number;
}

export function textNeedsTableDescriptionExpand(
  text: string,
  options?: TextNeedsTableDescriptionExpandOptions
): boolean {
  const maxChars = options?.maxSingleLineChars ?? DEFAULT_MAX_SINGLE_LINE_CHARS;
  const t = text.trim();
  if (!t) return false;
  if (t.includes("\n")) return true;
  if (t.length > maxChars) return true;
  return /[.!?]\s+\S/.test(t);
}
